import React from "react";

import { Consents } from "@/portals/(patient)/(consents)/components/Consents";
import { ContainerContent } from "@/components/Common/Dashboard/ContainerContent";
import { ContainerTitle } from "@/components/Common/Dashboard/ContainerTitle";

export function PatientConsents() {
  return (
    <ContainerContent>
      <ContainerTitle title="Consents" />
      <Consents />
    </ContainerContent>
  );
}
